import React from "react"
import { graphql, StaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Foreground from "../components/foreground"

const BackgroundSection = ({ className, page }) => (
  <StaticQuery
    query={graphql`
      query {
        desktop: file(relativePath: { eq: "store_tiny.jpg" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={data => {
      return (
        <BackgroundImage
          Tag="section"
          className={className}
          fluid={data.desktop.childImageSharp.fluid}
          backgroundColor={`#040e18`}
        >
          <div className="black-overlay">
            <Foreground page={page} />
          </div>
        </BackgroundImage>
      )
    }}
  />
)

export default BackgroundSection
